import * as React from 'react';
import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { periodTypeLabel } from '@utils/utils';

export default [
  {
    label: 'Jméno',
    field: 'label',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Popis',
    field: 'description',
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Barva',
    field: 'color',
    type: ColumnType.JSX,
    jsx: ({ row }) => (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        <span
          style={{
            display: 'inline-block',
            width: 20,
            height: 20,
            border: '1px solid #555',
            background: get(row, 'color'),
            marginRight: 10
          }}
        />{' '}
        {get(row, 'color')}
      </div>
    ),
    width: 200
  },
  {
    label: 'Intervaly',
    field: 'periods',
    type: ColumnType.JSX,
    jsx: ({ row }) => (
      <div>
        {get(row, 'periods', []).map((period: any) => (
          <div key={get(period, 'id')}>
            {periodTypeLabel(get(period, 'type'))} {get(period, 'from', '').substr(0, 5)} -{' '}
            {get(period, 'to', '').substr(0, 5)}
          </div>
        ))}
      </div>
    ),
    width: 200
  }
];



// WEBPACK FOOTER //
// ./src/modules/hr-templates/days/_daysColumns.tsx